module.exports = __webpack_public_path__ + "/b6880f9e0f918728e9eac6b913c1c036.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/docusign-switch/assets/feature_icons/pricing_icon_@2x.png
 ** module id = 946
 ** module chunks = 0
 **/